import React from 'react';

import Loading from 'components/atoms/Loading';

const LoadingPage: React.FC = () => (
  <div className="c-loading">
    <Loading variant="relative" />
  </div>
);

export default LoadingPage;
